import LogoImg from 'assets/logo.png'
import { twMerge } from 'tailwind-merge'

export default function Logo({ className }) {
  const cn = twMerge('h-16', className)
  return <img src={LogoImg} alt="logo" className={cn} />
}
